import { useQuery } from "@tanstack/react-query";
import { ProgramService } from "@/services/program.service";
import { useProgramsByUser } from "./useUsers";

export const useGetPrograms = ({ sortType = "asc" }: { sortType?: string }) => {
  const {
    data: programs,
    isLoading: isLoadingPrograms,
    isFetching: isFetchingPrograms,
    refetch: refetchPrograms,
  } = useQuery({
    queryKey: ["get-programs"],
    queryFn: () => ProgramService.getPrograms({ sortType }),
    staleTime: 1 * 60 * 60 * 1000,
  });

  return {
    programs,
    isLoadingPrograms,
    isFetchingPrograms,
    refetchPrograms,
  };
};

export const useGetUserPrograms = ({
  userId,
  sortType = "asc",
  hasSystemAdminRole,
}: {
  userId: string;
  sortType?: string;
  hasSystemAdminRole: boolean;
}) => {
  if (hasSystemAdminRole) {
    return useGetPrograms({ sortType });
  } else {
    return useProgramsByUser({ userId, sortType });
  }
};

export const useProgramBudget = (programId: string, enabled = true) => {
  const {
    data: budgetData,
    isLoading: isLoadingBudget,
    isError: isErrorBudget,
    refetch: refetchBudget,
  } = useQuery({
    queryKey: ["program-budget", programId],
    queryFn: () => ProgramService.getBudget(programId),
    staleTime: 1 * 60 * 1000, // 1 minute
    enabled: enabled && !!programId,
  });

  return {
    budgetData,
    isLoadingBudget,
    isErrorBudget,
    refetchBudget,
  };
};
